var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.45801 10.0545C1.45801 5.11477 5.47659 1.09619 10.4163 1.09619C12.6832 1.09619 14.8168 1.94952 16.458 3.45619V1.72119C16.458 1.37611 16.7379 1.09619 17.083 1.09619C17.4281 1.09619 17.708 1.37611 17.708 1.72119V5.05452C17.708 5.39961 17.4281 5.67952 17.083 5.67952H13.7497C13.4046 5.67952 13.1247 5.39961 13.1247 5.05452C13.1247 4.70944 13.4046 4.42952 13.7497 4.42952H15.6745C14.2549 3.09936 12.3938 2.34619 10.4163 2.34619C6.16584 2.34619 2.70801 5.80403 2.70801 10.0545C2.70801 10.3996 2.42809 10.6795 2.08301 10.6795C1.73792 10.6795 1.45801 10.3996 1.45801 10.0545ZM18.1247 10.0545C18.1247 14.305 14.6668 17.7629 10.4163 17.7629C8.43892 17.7629 6.57776 17.0097 5.15817 15.6795H7.08301C7.42809 15.6795 7.70801 15.3996 7.70801 15.0545C7.70801 14.7094 7.42809 14.4295 7.08301 14.4295H3.74967C3.40459 14.4295 3.12467 14.7094 3.12467 15.0545V18.3879C3.12467 18.7329 3.40459 19.0129 3.74967 19.0129C4.09476 19.0129 4.37467 18.7329 4.37467 18.3879V16.6529C6.01584 18.1595 8.14951 19.0129 10.4163 19.0129C15.3561 19.0129 19.3747 14.9943 19.3747 10.0545C19.3747 9.70944 19.0948 9.42953 18.7497 9.42953C18.4046 9.42953 18.1247 9.70944 18.1247 10.0545Z",
    fill: "#213A51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRefresh);
export default __webpack_public_path__ + "static/media/arrow-refresh.e0fb1780f804b17ec4e73165bf9b0c2f.svg";
export { ForwardRef as ReactComponent };